import { Extension } from '@tiptap/core'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import tippy from 'tippy.js'
import 'tippy.js/dist/tippy.css'
import TCVelikClient from '@/TCVelikClient/TCVelikClient';

export const TcvTableMenu = Extension.create({
  name: 'TcvTableMenu',

  addProseMirrorPlugins() {
    const extensionThis = this
    return [
      new Plugin({
        key: new PluginKey('tcv-table-menu'),
        view(editorView) {
          let popup = null;
          let menu = null;
          let tableRect
          let highlights = [];

          let lastRange = {
            from: null,
            to: null,
            isEmpty: true,
            text: ''
          };

          // Function to update menu position
          function updateMenuPosition() {
            if (!menu) return;

            const { selection } = editorView.state;
            const findTableAncestor = (pos) => {
              let depth = pos.depth;
              while (depth > 0) {
                const node = pos.node(depth);
                if (node.type.spec.tableRole === 'table') {
                  return { node, depth };
                }
                depth--;
              }
              return null;
            };

            const fromTable = findTableAncestor(selection.$from);
            if (!fromTable) {
              hideMenu();
              return;
            }

            const { depth: tableDepth } = fromTable;
            const tablePos = selection.$from.before(tableDepth);
            const tableDom = editorView.nodeDOM(tablePos);

            if (!tableDom) return;

            tableRect = tableDom.getBoundingClientRect();
            const bottomPosition = tableRect.bottom + 5;

            menu.style.position = 'fixed';
            menu.style.top = `${bottomPosition}px`;
            menu.style.left = `${tableRect.left}px`;
            menu.style.display = "block";
            menu.classList.add('visible', 'buttons-only');
          }

          const selectionInterval = setInterval(() => {
            const { selection } = editorView.state

            // Helper function to find closest table ancestor
            const findTableAncestor = (pos) => {
              let depth = pos.depth;
              while (depth > 0) {
                const node = pos.node(depth);
                if (node.type.spec.tableRole === 'table') {
                  return { node, depth };
                }
                depth--;
              }
              return null;
            };

            // Check if selection is within a table
            const fromTable = findTableAncestor(selection.$from);
            const toTable = findTableAncestor(selection.$to);

            const isInTable = fromTable && toTable && fromTable.depth === toTable.depth;

            if (!isInTable) {
              hideMenu()
              return
            }

            if (!lastRange ||
              lastRange.from !== selection.$from.pos ||
              lastRange.to !== selection.$to.pos) {

              lastRange = {
                from: selection.$from.pos,
                to: selection.$to.pos,
                text: editorView.state.doc.textBetween(selection.$from.pos, selection.$to.pos),
                isEmpty: false
              }

              if (!menu) {
                menu = createMenu();
                document.body.appendChild(menu);
              }

              updateMenuPosition();
            }
          }, 50)

          function createMenu() {
            const menuDiv = document.createElement('div')
            menuDiv.className = 'table-menu buttons-only'

            const tableButtonsDiv = document.createElement('div')
            tableButtonsDiv.className = 'table-buttons'
            tableButtonsDiv.style.display = 'flex'
            tableButtonsDiv.style.gap = '8px'
            tableButtonsDiv.style.justifyContent = 'center'

            const addRowButton = document.createElement('button')
            addRowButton.textContent = 'Add Row'
            addRowButton.onclick = () => {
              extensionThis.editor.commands.addRowAfter();
              // Update menu position after adding row
              setTimeout(updateMenuPosition, 0);
            }
            addRowButton.classList.add("btn", "btn-primary");

            const addColumnButton = document.createElement('button')
            addColumnButton.textContent = 'Add Column'
            addColumnButton.onclick = () => {
              extensionThis.editor.chain().focus().addColumnAfter().run();
              // Update menu position after adding column
              setTimeout(updateMenuPosition, 0);
            }
            addColumnButton.classList.add("btn", "btn-primary");

            const deleteColumnButton = document.createElement('button')
            deleteColumnButton.textContent = 'Delete Column'
            deleteColumnButton.onclick = () => {
              extensionThis.editor.commands.deleteColumn();
              // Update menu position after deleting column
              setTimeout(updateMenuPosition, 0);
            }
            deleteColumnButton.classList.add("btn", "btn-primary");

            const deleteRowButton = document.createElement('button')
            deleteRowButton.textContent = 'Delete Row'
            deleteRowButton.onclick = () => {
              extensionThis.editor.commands.deleteRow();
              // Update menu position after deleting row
              setTimeout(updateMenuPosition, 0);
            }
            deleteRowButton.classList.add("btn", "btn-primary");

            const deleteTableButton = document.createElement('button')
            deleteTableButton.textContent = 'Delete Table'
            deleteTableButton.onclick = () => {
              extensionThis.editor.commands.deleteTable();
              hideMenu();
            }
            deleteTableButton.classList.add("btn", "btn-danger");

            tableButtonsDiv.appendChild(addRowButton)
            tableButtonsDiv.appendChild(addColumnButton)
            tableButtonsDiv.appendChild(deleteColumnButton)
            tableButtonsDiv.appendChild(deleteRowButton)
            tableButtonsDiv.appendChild(deleteTableButton)

            menuDiv.appendChild(tableButtonsDiv)

            return menuDiv
          }

          function hideMenu() {
            if (menu) {
              menu.style.display = "none";
              menu.classList.remove('visible', 'buttons-only')
            }
          }

          // Listen for editor updates
          extensionThis.editor.on('update', updateMenuPosition)

          return {
            destroy() {
              if (menu) {
                extensionThis.editor.off('update')
                menu.remove()
                menu = null
              }
              clearInterval(selectionInterval)
            }
          }
        }
      })
    ]
  }
})
